import { useRef, useEffect } from 'react';

export default function AutoResizeTextarea({ value, onChange, readOnly = false, className = '', rows = 1, maxHeight = 200, ...rest }) {
  const ref = useRef(null);

  const resize = () => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    const newHeight = el.scrollHeight;
    if (newHeight > maxHeight) {
      el.style.height = `${maxHeight}px`;
      el.style.overflow = 'auto';
    } else {
      el.style.height = `${newHeight}px`;
      el.style.overflow = 'hidden';
    }
  };

  useEffect(() => {
    resize();
    const onWindowResize = () => resize();
    window.addEventListener('resize', onWindowResize);
    return () => window.removeEventListener('resize', onWindowResize);
  }, [value, maxHeight]);

  return (
    <textarea
      ref={ref}
      className={className}
      value={value}
      onChange={onChange}
      rows={rows}
      readOnly={readOnly}
      style={{ resize: 'vertical', boxSizing: 'border-box' }}
      {...rest}
    />
  );
}
